/* 🤖 this file was generated by svg-to-ts */
export const matIconHowToReg: {
  name: 'how-to-reg';
  data: string;
} = {
  name: 'how-to-reg',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2a9.34 9.34 0 0 0-1-.06c-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"/></svg>`
};
